import { render, staticRenderFns } from "./alarmRecord.vue?vue&type=template&id=06bc4c9c&scoped=true&"
import script from "./alarmRecord.vue?vue&type=script&lang=js&"
export * from "./alarmRecord.vue?vue&type=script&lang=js&"
import style0 from "./alarmRecord.vue?vue&type=style&index=0&id=06bc4c9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bc4c9c",
  null
  
)

export default component.exports